export default function SectionContainerDefault({ children }) {
  return (
    <div className='w-full py-6 md:py-10 px-5 md:px-[60px] lg:w-full lg:max-w-container-lg lg:mx-auto xl:container'>
      {children}
    </div>
  );
}
